import './styles.scss'
import PropTypes from 'prop-types'

const PageHead = ({ title, subtitle, marginBottom = 24, children }) => {
  return (
    <div className="content-header" style={{ marginBottom: marginBottom + 'px' }}>
      <div className="content-header-title-section">
        <span className="content-header-title-section-title">{title}</span>
        {
          children && <div className="content-header-title-section-btns">
            {children}
          </div>
        }
      </div>
      {
        subtitle && <>
          <br/>
          <div className="content-header-subtitle">{subtitle}</div>
        </>
      }
      <hr className="content-header-separator"/>
    </div>
  )
}
PageHead.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  marginBottom: PropTypes.number,
}
export default PageHead
